module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_500_1000.f4004a31.png";